import mapboxgl from "mapbox-gl";
import { CoamAreaFeature } from "../api/coamArea";
import { useCoamAreasLayer } from "../hooks/useCoamAreasLayer";

interface CoamAreasLayerProps {
  map: mapboxgl.Map | null;
  features: CoamAreaFeature[];
  selectedFeature: CoamAreaFeature | null;
  setSelectedFeature: (feature: CoamAreaFeature | null) => void;
}

export const CoamAreasLayer = ({
  map,
  features,
  selectedFeature,
  setSelectedFeature,
}: CoamAreasLayerProps) => {
  useCoamAreasLayer({ map, features, selectedFeature, setSelectedFeature });
  return null;
};

